// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/ADLaMDisplay-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/PublicSans-Light.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Google Font */

/* Custom Font */
@font-face {
  font-family: 'ADLaM Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Public Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}


.MuiBox-root.login-container {
  overflow-y: auto;
}

.MuiBox-root.imagecontainer {
  display: none;
}

@media screen and (min-width: 1024px) and (max-width: 1440px) {
  .MuiBox-root.imagecontainer {
    display: block;
    background-image: url('https://showcasaai.blob.core.windows.net/applicationasset/1440_Image.svg');
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    background-size: cover;
    object-fit: cover;
    background-position: center;
  }
}

@media screen and (min-width: 1441px) {
  .MuiBox-root.imagecontainer {
    display: block;
    background-image: url('https://showcasaai.blob.core.windows.net/applicationasset/1920_Image.svg');
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    background-size: cover;
    object-fit: cover;
    background-position: center;
  }
}

.apple-logo{
  width: 60px;
  height: 60px;
}
.google-logo{
  width: 60px;
  height: 60px;
}
.login-with{
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.MuiTypography-root.sigintext{
  font-family: var(--font-family-primary);
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}
.MuiTypography-root.registerTitle{
  font-family: var(--font-family-primary);
  font-weight: 400;
  font-size: 16px;
  color: #f0f0f0;
}
.MuiTypography-root.login-remember-label{
   font-size: 12px;
    font-family: var(--font-family-primary);
    font-weight: 400;
    color: #F0F0F0;
}
.MuiTypography-root.login-forgot-password{
  font-size: 12px;
    font-family: var(--font-family-primary);
    font-weight: 400;
    color: #fff;
    cursor: pointer;
    text-decoration: underline;
}
.MuiBox-root.signin-button .MuiButtonBase-root{ 
  width: 100%;
}
.MuiTypography-root.login-short{
    font-size: 12px;
    font-family: var(--font-family-primary);
    font-weight: 400;
    color: #F0F0F0;
    margin-bottom: 10px;
}
  .login-link{
    cursor: pointer;
    text-decoration: underline;
    color: #F0F0F0;
    font-family: var(--font-family-primary);
    font-weight: 400;
}
 .MuiTypography-root.forgot-verify{
    font-size: 16px;
    font-family: var(--font-family-primary);
    font-weight: 400;
    color: #F0F0F0;
  }`, "",{"version":3,"sources":["webpack://./src/components/Login/Login.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAGvB,gBAAgB;AAChB;EACE,4BAA4B;EAC5B,+DAAgE;EAChE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,+DAA4D;EAC5D,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;IACd,iGAAiG;IACjG,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,cAAc;IACd,iGAAiG;IACjG,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;GACG,eAAe;IACd,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;AAClB;AACA;EACE,eAAe;IACb,uCAAuC;IACvC,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,0BAA0B;AAC9B;AACA;EACE,WAAW;AACb;AACA;IACI,eAAe;IACf,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;EACE;IACE,eAAe;IACf,0BAA0B;IAC1B,cAAc;IACd,uCAAuC;IACvC,gBAAgB;AACpB;CACC;IACG,eAAe;IACf,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;EAChB","sourcesContent":["/* Import Google Font */\n@import url('https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;700&display=swap');\n\n/* Custom Font */\n@font-face {\n  font-family: 'ADLaM Display';\n  src: url('../fonts/ADLaMDisplay-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Public Sans';\n  src: url('../fonts/PublicSans-Light.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n\n.MuiBox-root.login-container {\n  overflow-y: auto;\n}\n\n.MuiBox-root.imagecontainer {\n  display: none;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1440px) {\n  .MuiBox-root.imagecontainer {\n    display: block;\n    background-image: url('https://showcasaai.blob.core.windows.net/applicationasset/1440_Image.svg');\n    background-repeat: no-repeat;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    object-fit: cover;\n    background-position: center;\n  }\n}\n\n@media screen and (min-width: 1441px) {\n  .MuiBox-root.imagecontainer {\n    display: block;\n    background-image: url('https://showcasaai.blob.core.windows.net/applicationasset/1920_Image.svg');\n    background-repeat: no-repeat;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    object-fit: cover;\n    background-position: center;\n  }\n}\n\n.apple-logo{\n  width: 60px;\n  height: 60px;\n}\n.google-logo{\n  width: 60px;\n  height: 60px;\n}\n.login-with{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.MuiTypography-root.sigintext{\n  font-family: var(--font-family-primary);\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n}\n.MuiTypography-root.registerTitle{\n  font-family: var(--font-family-primary);\n  font-weight: 400;\n  font-size: 16px;\n  color: #f0f0f0;\n}\n.MuiTypography-root.login-remember-label{\n   font-size: 12px;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    color: #F0F0F0;\n}\n.MuiTypography-root.login-forgot-password{\n  font-size: 12px;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    color: #fff;\n    cursor: pointer;\n    text-decoration: underline;\n}\n.MuiBox-root.signin-button .MuiButtonBase-root{ \n  width: 100%;\n}\n.MuiTypography-root.login-short{\n    font-size: 12px;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    color: #F0F0F0;\n    margin-bottom: 10px;\n}\n  .login-link{\n    cursor: pointer;\n    text-decoration: underline;\n    color: #F0F0F0;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n}\n .MuiTypography-root.forgot-verify{\n    font-size: 16px;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    color: #F0F0F0;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
